<template>
  <div class="modal-wrapper" @click="onCancelActionPerformed">
    <div class="modal" @click.stop>
      <div class="header">
        <span class="close-icon" @click="onCancelActionPerformed">&times;</span>
        <h3 v-if="plate['text'] === ''">Añade un nuevo plato</h3>
        <h3 v-else>Edita el plato</h3>
      </div>
      <textarea
        ref="textarea"
        v-model="updatedPlate['text']"
        class="textarea"
      ></textarea>
      <div class="allergens-container">
        <label
          v-for="allergenId in Object.keys(allergens)"
          :key="allergenId"
          class="allergen"
        >
          <input
            type="checkbox"
            :value="allergenId"
            :name="allergenId"
            v-model="updatedPlate['allergens']"
          />
          <img
            :src="require(`@/assets/icons/allergens/${allergenId}.svg`)"
            alt=""
          />
          {{ allergens[allergenId] }}
        </label>
      </div>
      <div class="options">
        <div @click="onCancelActionPerformed" class="cancel-option">
          Cancelar
        </div>
        <div @click="onSaveButtonClicked" class="button">Guardar</div>
      </div>
    </div>
  </div>
</template>

<script>
import json from "@/assets/allergens.json";

export default {
  name: "PlateEditDialog",
  props: {
    title: {
      type: String,
      required: true,
    },
    plate: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      allergens: json,
      updatedPlate: this.plate
        ? Object.assign({}, this.plate)
        : { text: "", allergens: [] },
    };
  },
  methods: {
    onSaveButtonClicked() {
      this.$emit("save-plate", this.updatedPlate);
    },
    onCancelActionPerformed() {
      this.$emit("cancel-save-plate");
    },
  },
  mounted() {
    this.$refs.textarea.focus();
  },
};
</script>

<style scoped>
.modal-wrapper {
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
}

.modal {
  background-color: white;
  margin: 15% auto;
  padding: 1rem 2rem;
  border: 1px solid #888;
  width: 40rem;
  border-radius: 3px;
}

.header {
  position: relative;
}

.close-icon {
  position: absolute;
  top: -1rem;
  right: 1px;
}

.textarea {
  width: 100%;
  min-height: 3rem;
  margin-bottom: 1rem;
}

.allergens-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
}

.allergen {
  padding: 0 0.5rem;
  font-size: 0.9rem;
  white-space: nowrap;
}
.allergen img {
  width: 20px;
}

.options {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 1rem;
}

.cancel-option {
  margin-right: 2rem;
  font-size: 0.8rem;
  font-weight: 900;
}

.button {
  box-sizing: content-box;
  background-color: lightcoral;
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
  font-size: 0.8rem;
  font-weight: 900;
  border-radius: 3px;
}

.button:hover,
.cancel-option:hover,
.close-icon:hover {
  cursor: pointer;
  opacity: 0.8;
}
</style>
